class SpeakersLightbox2020 {
  constructor() {
    this.close = document.querySelector('.btn-close');
    this.component = document.getElementById('lightBox2020');
    this.elements = document.querySelectorAll('[data-info]');
    this.flagCountry = document.querySelector('#lightBox2020 #speaker-thumb-country');

    if (!this.component) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    this.close.addEventListener('click', this.onClickClose.bind(this));
    Array.prototype.forEach.call(this.elements, (element) => {
      element.addEventListener('click', this.onClickOpen.bind(this));
    });
  }

  onClickClose() {
    this.component.classList.remove('active');
    document.body.classList.remove('light-box-active');
  }

  onClickOpen(event) {
    if (
      event.target.parentElement.classList.contains('speakers-thumb-social') ||
      event.target.classList.contains('speakers-thumb-social')
    ) {
      return;
    }

    const data = JSON.parse(event.currentTarget.getAttribute('data-info'));
    const flag = event.currentTarget.getAttribute('data-country-flag');
    const stamp = event.currentTarget.getAttribute('data-stamp') ?? '';

    if (!data) {
      return;
    }

    event.preventDefault();

    document.body.classList.add('light-box-active');

    document.body.style.position = 'relative';
    document.getElementById('image-speaker').src = data.image;
    document.getElementById('name-speaker').innerHTML = data.name;
    document.getElementById('role-speaker').innerHTML = data.role;
    document.getElementById('description-speaker').innerHTML = data.description;

    ['linkedin', 'instagram'].forEach((socialMedia) => {
      const socialMediaLink = document.getElementById(`${socialMedia}-speaker`);

      if (data[socialMedia] === '') {
        socialMediaLink.style.display = 'none';
      } else {
        socialMediaLink.href = data[socialMedia];
        socialMediaLink.style.display = 'inline-block';
      }
    });

    if (flag) {
      this.flagCountry.style.backgroundImage = `url(${flag})`;
      this.flagCountry.style.display = 'block';
    } else {
      this.flagCountry.style.backgroundImage = '';
      this.flagCountry.style.display = 'none';
    }

    const speakerContainer = this.component.querySelector('.lightBox2020-speaker');
    speakerContainer.classList.toggle('has-stamp', !!stamp);
    speakerContainer.style.setProperty('--speaker-event-stamp', stamp ? `url(${stamp})` : '')

    this.component.classList.add('active');
  }
}

export default new SpeakersLightbox2020();
